import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getBannerFn = () => {
    const response = protectedApi.get(`${ENDPOINTS.banner_api}`);
    return response;
}

export const getBannerByIdFn = (id) => {
    const response = protectedApi.get(`${ENDPOINTS.banner_api}?banner_id=${id}`);
    return response;
}

export const postBannerFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.banner_api}`, reqBody);
    return response;
}

export const patchBannerFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.banner_api}`, reqBody);
    return response;
}

export const deleteBannerFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.banner_api}`, { data: reqBody });
    return response;
}

export const getCategoryFn = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.category}`, { params: req });
    return response;
}

export const getSubCategoryFn = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.subcategory}`, { params: req });
    return response;
}

export const getsubSubCategoryFn = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.subsubcategory}`, { params: req });
    return response;
}


